import { XeroAuthorizeResponseSchema, XeroCallbackResponseSchema, XeroAccountsResponseSchema, XeroConnectionResponseSchema, XeroConnectionSettingsBodySchema, XeroDisconnectResponseSchema, XeroExportInvoiceBodySchema, XeroExportInvoiceResponseSchema, } from '@packages/types';
import { api, ApiError } from '../client.js';
export async function getXeroConnection(accountId) {
    try {
        return await api(`/accounts/${accountId}/xero/connection`, XeroConnectionResponseSchema);
    }
    catch (error) {
        if (error instanceof ApiError && error.status === 404) {
            return null;
        }
        throw error;
    }
}
export function getXeroAuthorizeUrl(accountId, returnTo) {
    return api(`/accounts/${accountId}/xero/connect/authorize?returnTo=${encodeURIComponent(returnTo)}`, XeroAuthorizeResponseSchema);
}
export function handleXeroCallback(accountId, body) {
    return api(`/accounts/${accountId}/xero/connect/callback`, XeroCallbackResponseSchema, {
        method: 'POST',
        body,
    });
}
export function selectXeroTenant(accountId, body) {
    return api(`/accounts/${accountId}/xero/select-tenant`, XeroConnectionResponseSchema, {
        method: 'POST',
        body,
    });
}
export function disconnectXero(accountId) {
    // DELETE per HTTP spec - no body, no Content-Type: application/json header
    return api(`/accounts/${accountId}/xero/connection`, XeroDisconnectResponseSchema, {
        method: 'DELETE',
    });
}
export function reconnectXero(accountId, returnTo) {
    // POST with explicit empty body to satisfy Fastify body schema (z.object({}))
    const qs = returnTo ? `?returnTo=${encodeURIComponent(returnTo)}` : '';
    return api(`/accounts/${accountId}/xero/reconnect${qs}`, XeroAuthorizeResponseSchema, {
        method: 'POST',
        body: {},
    });
}
export function getXeroAccounts(accountId) {
    return api(`/accounts/${accountId}/xero/accounts`, XeroAccountsResponseSchema);
}
export function updateXeroConnectionSettings(accountId, body) {
    return api(`/accounts/${accountId}/xero/connection/settings`, XeroConnectionResponseSchema, {
        method: 'PUT',
        body: XeroConnectionSettingsBodySchema.parse(body),
    });
}
export function exportInvoiceToXero(accountId, invoiceId, body) {
    return api(`/accounts/${accountId}/xero/invoices/${invoiceId}/export`, XeroExportInvoiceResponseSchema, {
        method: 'POST',
        body: XeroExportInvoiceBodySchema.parse(body),
    });
}
